import FormStep from '../../Form/FormStep';
import API from '../../../api';

export default {
	mixins: [FormStep],
	methods: {

	}
}
